/**
 * The font the Synth VR scene's text is drawn with (SRVR-0341).
 *
 * troika, which draws every drei `<Text>`, resolves any character its `font` does not cover through a
 * font index and font files on cdn.jsdelivr.net — and with no `font` at all, that is every character,
 * so a bookmark name needed the internet (CAND-AK). This is Roboto Regular (OFL 1.1) served from
 * `public/fonts/roboto/`: one file, because troika 0.52 takes a single font URL, merged from
 * `@fontsource/roboto`'s latin, latin-ext, cyrillic, greek and vietnamese subsets (the recipe is in
 * docs/knowledge/scene-text-fonts.md). `.woff` because troika cannot read `.woff2`. Characters outside
 * those subsets (Hangul, CJK, emoji) still go to the CDN: a measured limit.
 */
import type { ActiveView } from '../../store/editorSettings';

/** Under the SPA's base path (`PUBLIC_URL` is '' at the root). */
export const SCENE_FONT = `${process.env.PUBLIC_URL ?? ''}/fonts/roboto/roboto-regular.woff`;

/** The font for scene text in a view: the bundled one in Synth VR, and nothing — troika's default, as
 *  before — everywhere else (the Console variant shares these components and is not changed). */
export function sceneFontFor(view: ActiveView): string | undefined {
  return view === 'synth-rider' ? SCENE_FONT : undefined;
}
